
import { Subject, Observable, timer, Subscription, BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { OrderNofeshChulComponent } from "app/nofshonim-chul/order/order-nofshon-chul.component";
import { runInThisContext } from "vm";
import { ConfigService } from "../config.service";
import { PirteyTashlumComponent } from "app/nofshonim-chul/pirtey-tashlum/pirtey-tashlum.component";
import { NofshonChulEndRishumComponent } from "app/nofshonim-chul/nofshon-chul-end-rishum/end-rishum.component";
import { HomeComponent } from "app/nofesh/home/home.component";


const ONE_MINUTE = 60;

@Injectable({ providedIn: "root" })
export class NofshonReservationTimerService
{
    private readonly _timerPeriodMinutes: number;
    private readonly _timerTimeoutSeconds: number;
    private readonly _validMandatoryValues: boolean = false;

    private readonly _minimalSecondsToStopNofshonReservationTimer: number;
    
    private _isTimerShown : boolean = false;
    private _isTimerTimedOut: boolean = false;
    private _minutesLeft: number = 0;
    private _secondsLeft:number = 0;
    private _previousCountdownTotalSeconds: number = 0;
    private _remainedTime: string;
    private _reservationTimerSubscription: Subscription;



    private _showTimerSource : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    showTimer$ : Observable<boolean> = this._showTimerSource.asObservable();

    private _currentTimerSource : Subject<string>  = new Subject<string>();
    currentTimer$ : Observable<string> = this._currentTimerSource.asObservable();

    private _timeoutSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    timerTimeout$: Observable<boolean> = this._timeoutSource.asObservable();

    
    get isTimerShown() { return this._isTimerShown };
    get timerPeriod() { return this._timerPeriodMinutes };



    constructor(private _configService: ConfigService)
    {
        this._minimalSecondsToStopNofshonReservationTimer = this._configService.getConfigPropertyByKey("minimalSecondsToStopNofshonReservationTimer");
        const timerMinutesInConfig = this._configService.getConfigPropertyByKey("nofshonReservationTimerMinutes");
        if(timerMinutesInConfig && (typeof timerMinutesInConfig === "number" || !isNaN(+timerMinutesInConfig)))
        {
            this._timerPeriodMinutes = +timerMinutesInConfig;
            this._timerTimeoutSeconds = ONE_MINUTE * this._timerPeriodMinutes;
            this._validMandatoryValues = true;
            this._initTimerValues();
        }
        else
        {
            console.error("Missing mandatory timer config");
        }
    }

    private _initTimerValues(): void
    {
        this._minutesLeft = this._timerPeriodMinutes;
        this._secondsLeft = ONE_MINUTE;
    }


    getReservationExpiration(moedRishum: Date): number
    {
        if(typeof moedRishum === "string")
        {
            moedRishum = new Date(moedRishum);
        }
        let expiration = moedRishum.getTime() + (this._timerTimeoutSeconds * 1000);
        return expiration;
    }

    checkIfInMinimalPeriodToStopTimer(moedRishum: Date): boolean
    {
        const expiration = this.getReservationExpiration(moedRishum);
        const now = new Date().getTime();

        const result = (expiration - now) <= (this._minimalSecondsToStopNofshonReservationTimer * 1000);

        console.log("Timer service - minimal timer?", result);

        return result;
    }

    checkIfTimerTimedOut(timerTimeout: number): boolean
    {
        const isTimeout = new Date().getTime() >= timerTimeout;
        return isTimeout;
    }    

    startTimer(): void
    {
        if(this._isTimerShown)
        {
            return;
        }

        if(!this._reservationTimerSubscription)
        {
            this._reservationTimerSubscription = this._showTimer();
        }
    }

    resumeTimer(timerExpiration: number): void
    {
        const remainedMs = timerExpiration - new Date().getTime();
        let seconds = remainedMs / 1000;
        const minutes = Math.floor(seconds / 60);

        seconds = Math.floor(seconds % 60);

        this._minutesLeft = minutes;
        this._secondsLeft = seconds;
        this._previousCountdownTotalSeconds = this._timerTimeoutSeconds - ((this._minutesLeft * ONE_MINUTE) + this._secondsLeft);

        if(!this._reservationTimerSubscription)
        {
            this._reservationTimerSubscription = this._showTimer();
        }
    }

    showTimedOutTimer(): void
    {
        this._isTimerShown = true;
        this._showTimerSource.next(this._isTimerShown);
        this._notifyTimerTimeout();
        if(this._reservationTimerSubscription)
        {
            this.stopTimer();
        }
        this._resetTimer();
    }

    private _showTimer(): Subscription
    {
        this._isTimerShown = true;
        this._isTimerTimedOut = false;
        this._showTimerSource.next(this._isTimerShown);
        console.log("Timer service - show timer - notifying timer timeout is not timed out");
        this._timeoutSource.next(this._isTimerTimedOut);
        const subscription = timer(0, 1000).subscribe((time: number) => this._timerCountdown(time));
        return subscription;
    }


    private _timerCountdown(time: number): void
    {
        if(isNaN(this._minutesLeft) || isNaN(this._secondsLeft))
        {
            console.error(`Timer has invalid value. Minutes: '${this._minutesLeft}', seconds: '${this._secondsLeft}'`);
            this._reservationTimerSubscription.unsubscribe();
            return;
        }

        if(this._previousCountdownTotalSeconds > 0)
        {
            time = this._previousCountdownTotalSeconds++;
        }

        let minutes: string = "";
        let seconds: string = "";

        minutes = (this._minutesLeft >= 0 && this._minutesLeft < 10)
            ? `0${this._minutesLeft}` 
            : `${this._minutesLeft}`;

        if (time % 60 === 0)
        {
            seconds = "00";
            this._minutesLeft--;
            this._secondsLeft = ONE_MINUTE;

        }
        else
        {
            seconds = (this._secondsLeft >= 0 && this._secondsLeft < 10)
            ? `0${this._secondsLeft}`
            : `${this._secondsLeft}`;
        }
                
        this._remainedTime = `${minutes}:${seconds}`;
        this._secondsLeft--;
        
        // console.log(time, this._remainedTime);

        this._currentTimerSource.next(this._remainedTime);      

        if(time === this._timerTimeoutSeconds + 1)
        {
            console.log("Timer service - timer countdown timeout");
            this._notifyTimerTimeout();
            this.stopTimer();
            this._resetTimer();
        }
    }

    private _notifyTimerTimeout(): void
    {
        console.log("Timer service - timeout! Notifying subscribers");
        this._isTimerTimedOut = true;
        this._timeoutSource.next(this._isTimerTimedOut);
    }

    stopTimer(): void
    {
        if(this._reservationTimerSubscription)
        {
            this._reservationTimerSubscription.unsubscribe();
        }
        this._reservationTimerSubscription = null;
    }
    
    hideTimer(): void
    {
        this._isTimerShown = false;
        this._showTimerSource.next(this._isTimerShown);
        this._isTimerTimedOut = false;
        console.log("Timer service - hide timer");
        this._timeoutSource.next(this._isTimerTimedOut);
        this._resetTimer();
    }

    private _resetTimer(): void
    {
        this._previousCountdownTotalSeconds = 0;
        this._remainedTime = null;
        this._initTimerValues();
    }
}